import { IAction, ActionType, ISetPageAction, setPage } from '../actions/index';
import { IPage, initialPageModel } from '../state-helpers/page';
import * as _ from 'lodash';

export function pageModel(state: IPage, action: ISetPageAction) {
    if (typeof state === 'undefined') {
        state = initialPageModel;
    }

    switch (action.type) {
        case ActionType.SET_PAGE:
            return _.assign({}, state, { page: action.page });//{ pageModel: { page: action.page, pageSize: 10 }});//state;//setPage(action.page).page;//
        default:
            return state;
    }
}

//function getPage(pageNumber: number): IPage {
//    if (pageNumber == 0) {
//        pageNumber = 1;
//    }

//    page.page = pageNumber;
//    return page;
//}